export default {
  searchTerm: state => state.searchTerm,
  pageSize: state => state.pageSize,
  sortDir: state => state.sortDir,
  orderBy: state => state.orderBy,
  status: state => state.status,
  filterBy: state => state.filterBy,
  requests: state => state.requests,
  totalRequests: state => state.totalRequests,
  schema: state => state.schema,
  queryTemplates: state => state.queryTemplates,
  logicChoices: state => state.logicChoices,
  categoryChoices: state => state.categoryChoices,
  currentTemplate: state => state.currentTemplate
}



// WEBPACK FOOTER //
// ./src/store/modules/dashboard/getters.js